export const alphaList = (array) =>
  array.reduce((obj, item) => {
    let key = item.nom[0].toUpperCase();
    obj[key] = obj[key] || [];
    obj[key].push(item);
    return obj;
  }, {});
